import React, { useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useQueryClient } from "@tanstack/react-query"
import { useGroupDetail, useModifyGroup, useModifyGroupMember, useDeleteGroup } from "../../../../api/admin/group/hooks"
import GroupForm from "../../../organisms/GroupForm"
import { showAlert } from "../../../../reducer/alertSlice"

/**
 * 그룹 상세 화면 - 관리자
 */
const GroupDetail = () => {
    const navigate  = useNavigate()
    const dispatch = useDispatch
    const user = useSelector(state => state.auth.user)
    // 유저 권한 - 0: 일반, 1: 중간, 2: 최고
    const [userGrade] = useState(user.grade)
    const groupIdx = useLocation().pathname.split("/").pop()
    const { data } = useGroupDetail(groupIdx)
    const groupDetail = data?.data || []

    const { mutateAsync: modifyGroup, isLoading: modifyingGroup } = useModifyGroup()
    const { mutateAsync: modifyGroupMember, isLoading: modifyingGroupMember } = useModifyGroupMember()
    const { mutate: deleteGroup } = useDeleteGroup()
    const qc = useQueryClient()

    useEffect(() => {
        if (data) {
            console.log("@admin/GroupDetail", groupDetail);
        }
    }, [data])

    const modifyHandler = async ({ title, description, selectedUserList }) => {
        try {
            // 그룹 수정, 그룹 참여 인원 수정 API 를 병렬로 동시 호출
            await Promise.all([
                // 그룹 수정은 최고 관리자 권한일때만 요청한다
                ...(userGrade === "2" ? [modifyGroup(
                    { idx: groupIdx, title, description }, 
                    {
                        onError: err => {
                            if (err?.response?.data?.code === -14) {
                                dispatch(showAlert({
                                    msg: '이미 존재하는 그룹명 입니다.'
                                }))
                            }
                        }
                    }
                )] : []),
                modifyGroupMember(
                    { groupIdx, userIdxList: selectedUserList }
                ),
            ])
            console.log("@admin/GroupDetail - modifyGroup & modifyGroupMember Success")
            //  groupDetail 쿼리 키를 무효화 → 백그라운드에서 다시 fetch (데이터 캐싱 대신 최신 상태로 유지)
            qc.invalidateQueries(['groupDetail', groupIdx])
            navigate("/admin/group/list")
        } catch (err) {
            console.error("@admin/GroupDetail - modifyGroup & modifyGroupMember Error", err)
        }
    }

    const deleteHandler = () => {
        deleteGroup(
            { idx: groupIdx },
            {
                onSuccess: (data) => {
                    switch (data.code) {
                        case 0:
                            console.log("@GroupDetail - deleteGroup Success")
                            navigate("/admin/group/list")
                            break
                        default:
                            console.log("@GroupDetail - deleteGroup Success But data.code != 0")
                    }
                },
                onError: err => console.error("@GroupDetail - deleteGroup Error", err)
            }
        )
    }

    if (!groupDetail) return null
    return (
        <GroupForm
            initData={{
                title: groupDetail.name,
                description: groupDetail.description,
                groupUsers: groupDetail.user || []
            }}
            editable={true}
            isModify={true}
            onSubmit={modifyHandler}
            onDelete={deleteHandler}
        />
    )
}

export default GroupDetail